import axios, { AxiosError } from 'axios';
import { API_BASE_URL } from '../constants';
import { installAuth } from './authInterceptor';

const instance = axios.create({
  baseURL: API_BASE_URL,
});
installAuth(instance);

function extractErrorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<{ message?: string }>;
    return axiosError.response?.data?.message || fallback;
  }
  return fallback;
}

const client = {
  get: async <T = unknown>(path: string): Promise<T> => {
    try {
      const response = await instance.get<T>(path);
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error, `Request failed`));
    }
  },
  post: async <T = unknown>(path: string, body?: Record<string, unknown>): Promise<T> => {
    try {
      const response = await instance.post<T>(path, body);
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error, `Request failed`));
    }
  },
  postForm: async <T = unknown>(path: string, formData: FormData): Promise<T> => {
    try {
      const response = await instance.post<T>(path, formData);
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error, `Request failed`));
    }
  },
};

export default client;
